import ReorderItem from './reorder-item.element.js';

export default ReorderItem;

ReorderItem.define('wje-reorder-item', ReorderItem);
